import { useCallback } from 'react';

export function useCurrencyHelpers({ lkrRate, usdRate, baseCurrency }) {
    const baseSymbol = baseCurrency === 'LKR' ? '₨' : baseCurrency === 'USD' ? '$' : '$';
    const baseCurrencyLabel = baseCurrency;

    const toBase = useCallback((amount, fromCurrency) => {
        const n = parseFloat(amount) || 0;
        const lkrPerSgd = typeof lkrRate === 'number' ? lkrRate : (parseFloat(lkrRate) || 245);
        const sgdPerUsd = typeof usdRate === 'number' ? usdRate : (parseFloat(usdRate) || 1.26);

        let inSGD;
        if (fromCurrency === 'SGD') inSGD = n;
        else if (fromCurrency === 'LKR') inSGD = n / lkrPerSgd;
        else if (fromCurrency === 'USD') inSGD = n * sgdPerUsd;
        else inSGD = n;

        if (baseCurrency === 'SGD') return inSGD;
        else if (baseCurrency === 'LKR') return inSGD * lkrPerSgd;
        else if (baseCurrency === 'USD') return inSGD / sgdPerUsd;
        return inSGD;
    }, [lkrRate, usdRate, baseCurrency]);

    const fmtBase = useCallback((amount, { compact = false, decimals } = {}) => {
        const n = parseFloat(amount) || 0;
        if (compact) {
            if (Math.abs(n) >= 1_000_000) return `${baseSymbol}${(n / 1_000_000).toFixed(1)}M`;
            if (Math.abs(n) >= 1_000) return `${baseSymbol}${Math.round(n / 1000)}K`;
            return `${baseSymbol}${Math.round(n).toLocaleString()}`;
        }
        const dp = decimals !== undefined ? decimals : (baseCurrency === 'LKR' ? 0 : 2);
        return `${baseSymbol}${n.toLocaleString(undefined, { minimumFractionDigits: dp, maximumFractionDigits: dp })}`;
    }, [baseSymbol, baseCurrency]);

    // Frequency mapping: monthly → 1, quarterly → 1/3, annual → 1/12,
    // one-time → 0 (excluded from monthly cash-flow but kept in list).
    const FREQUENCY_FACTOR = { monthly: 1, quarterly: 1 / 3, annual: 1 / 12, 'one-time': 0 };
    const toMonthlyBase = useCallback((income) => {
        if (!income || income.enabled === false) return 0;
        const factor = FREQUENCY_FACTOR[income.frequency] != null
            ? FREQUENCY_FACTOR[income.frequency] : 1;
        return toBase(parseFloat(income.amount) || 0, income.currency || 'SGD') * factor;
    }, [toBase]);

    return { toBase, fmtBase, toMonthlyBase, baseSymbol, baseCurrencyLabel };
}
